// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAvatar_wrapper__2wCYO","profilePhoto":"UserAvatar_profilePhoto__3ljpQ","missingAvatar":"UserAvatar_missingAvatar__3m3lT"};